(function () {

  function initLeadTime(scope = document) {
    const container = scope.querySelector('[data-lead-time-container]');
    if (!container) return;
    const valueEl = container.querySelector('[data-lead-time-value]');
    const shippingInput = scope.querySelector('[data-shipping-note]');
    const privateShippingInput = document.querySelector('[data-hidden-shipping-note]');
    const format = (days) => {
      days = parseInt(days) || 0;
      if ([14, 21].includes(days)) {
        const weeks = days / 7;
        return `${weeks} ${weeks > 1 ? 'weeks' : 'week'}`;
      }
      if (days === 30) return '1 month';
      return `${days} ${days !== 1 ? 'days' : 'day'}`;
    };
    const getVariantId = () => {
      const el = scope.querySelector('form[action*="/cart/add"] [name="id"]');
      return el ? el.value : null;
    };
    const updateDataFromVariant = (id) => {
      const hidden = scope.querySelector('.lead_values');
      if (!hidden) return;
      let variantData;
      try {
        variantData = JSON.parse(hidden.value);
      } catch (e) {
        console.error("Invalid JSON in lead_values", e);
        return;
      }
      const data = variantData[id];
      if (!data) return;
      container.dataset.base = data.lead_time;
      container.dataset.monoType = data.mono_type;
      const quickViewaddBtn = scope.querySelector('.quick-view-form__button');
      const acceleratedWrapper = scope.querySelector('.shopify-payment-button');
      if (quickViewaddBtn) {
        if (data.available) {
          if (data.mono_type === 'required') {
          quickViewaddBtn.textContent = 'Customize';
          } else {
            quickViewaddBtn.textContent = 'Add to Cart';
          }
        } else {
          quickViewaddBtn.textContent = 'Sold out';
        }
      }
    if (acceleratedWrapper) {
      if (data.mono_type === 'optional' || data.mono_type === 'required') {
        acceleratedWrapper.style.pointerEvents = 'none';
        acceleratedWrapper.style.opacity = '0.6';
        acceleratedWrapper.style.cursor = 'not-allowed';
      } else {
        acceleratedWrapper.style.pointerEvents = '';
        acceleratedWrapper.style.opacity = '';
        acceleratedWrapper.style.cursor = '';
      }
    }
    };
    const updateLeadTime = () => {
      let base =
        parseInt(container.dataset.base) ||
        parseInt(container.dataset.default) || 2;
      const text = format(base);

      if (valueEl) valueEl.textContent = text;
      if (shippingInput) shippingInput.value = `Ships within ${text}`;
      if (privateShippingInput) privateShippingInput.value = `${base}`;
    };
    const handleVariantChange = () => {
      setTimeout(() => {
        const id = getVariantId();
        if (id) updateDataFromVariant(id);
        updateLeadTime();
      }, 10);
    };
    /* Scoped change listener */
    scope.addEventListener('change', function (e) {
      if (e.target.matches('[name="id"], input[name^="option"]') || e.target.matches('.product-quantity__input')) {
        handleVariantChange();
      }

    });
    /* Initial load */
    const initialId = getVariantId();
    if (initialId) updateDataFromVariant(initialId);
    updateLeadTime();
  }
  function blockQuickViewButton(container) {
    const buttons = container.querySelectorAll('.quick-view-form__button');
    buttons.forEach(function (btn) {
      if (btn.dataset.processed === "true") return;
      btn.dataset.processed = "true";
      btn.addEventListener('click', async function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        const leadContainer = container.querySelector('[data-lead-time-container]');
        const monoType = leadContainer?.dataset?.monoType;
        if (monoType === 'required') {
          const formvariant = btn.closest('form');
          const variantInput = formvariant?.querySelector('[name="id"]');
          const productLink = container.querySelector('a[href*="/products/"]');
          if (productLink && variantInput?.value) {
            const baseUrl = productLink.href.split('?')[0];
            window.location.href = `${baseUrl}?variant=${variantInput.value}`;
          }
          return;
        }
        const form = btn.closest('form');
        if (!form) return;
        if (btn.dataset.loading === "true") return;
        btn.dataset.loading = "true";
        btn.disabled = true;
        const variantInput = form.querySelector('[name="id"]');
        if (!variantInput || !variantInput.value) {
          console.warn("No variant selected");
          btn.disabled = false;
          btn.dataset.loading = "false";
          return;
        }
        const variantId = variantInput.value;
        const quantityInput = form.querySelector('[name="quantity"]');
        const quantity = quantityInput ? parseInt(quantityInput.value) : 1;
        const properties = {};

        const propertyInputs = form.querySelectorAll('[name^="properties["]');
        const quantityError = form.querySelector('.js-product-quantity-error');

        propertyInputs.forEach(input => {
          const match = input.name.match(/properties\[(.*?)\]/);
          if (!match) return;

          const key = match[1];
          properties[key] = input.value;
        });

        try {

          await window.themeCore.CartApi.makeRequest(
            window.themeCore.CartApi.actions.ADD_TO_CART,
            {
              id: variantId,
              quantity: quantity,
              properties: properties
            }
          );

          await window.themeCore.CartApi.makeRequest(
            window.themeCore.CartApi.actions.GET_CART
          );

        } catch (error) {
          console.error("Add to cart error:", error);
          quantityError.innerHTML = error.description
        }
        const loader = document.querySelector(`[data-js-overlay="CartDrawer"] .loader`);
        if (loader) {
          loader.remove();
        }
        btn.disabled = false;
        btn.dataset.loading = "false";

      }, true);

    });

  }
  function quantityInpuValidation(container) {
    if (container.dataset.quantityValidationInit) return;
    container.dataset.quantityValidationInit = "true";
    const quantityInput = container.querySelector('[data-quantity-input]');
    const increaseBtn = container.querySelector('[data-quantity-increase]');
    const variantSelector = container.querySelectorAll('input.radio-input');
    const quantityError = container.querySelector('.js-product-quantity-error');
    const quickViewLink = container.querySelector('.js-quick-view-link');
    const productInventoryInfo = container.querySelector(selectors.productInventory);

    if (!quantityInput || !increaseBtn || !quickViewLink || !productInventoryInfo) return;

   let inventoryMap = {};

    try {
      const parsedInventory = JSON.parse(productInventoryInfo.innerText);

      inventoryMap = Object.fromEntries(
        parsedInventory
          .filter(v => v.inventory_management === "shopify")
          .map(v => [v.id, v.inventory_quantity])
      );

    } catch (e) {
      console.error("Invalid inventory JSON", e);
    }

    function getVariantId() {
      const url = new URL(quickViewLink.href);
      return Number(url.searchParams.get('variant'));
    }

    function validateQuantity() {
      setTimeout(() => {
      const variantId = getVariantId();
      const inventoryQuantity = inventoryMap[variantId];
      if (inventoryQuantity == null){
        increaseBtn.disabled = false;
        return;
      }
      let value = Number(quantityInput.value) || 1;
      value = Math.max(1, Math.min(value, inventoryQuantity));
      quantityInput.value = value;
      increaseBtn.disabled = value >= inventoryQuantity;
    }, 0);
    }

    quantityInput.addEventListener('input', validateQuantity);
    quantityInput.addEventListener('change', validateQuantity);
    increaseBtn.addEventListener('click', validateQuantity);
    variantSelector.forEach(selector => {
      selector.addEventListener('change', () => {
        quantityInput.value = 1;
        if (quantityError) quantityError.innerHTML = '';
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        setTimeout(validateQuantity, 0);
      });
    });
    validateQuantity();
  }
  /* Quick View Observer */
  const observer = new MutationObserver(() => {
    const popup = document.querySelector('.js-quick-view');
    if (popup && !popup.dataset.leadTimeInit) {
      popup.dataset.leadTimeInit = "true";
      initLeadTime(popup);
      blockQuickViewButton(popup);
    }
    if (popup) {
      quantityInpuValidation(popup);
    }

  });
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  //cart update
  async function refreshCartSections() {
    const sections = document.querySelectorAll('[data-section-type="cart-template"]');
    if (!sections.length) return;

    const sectionIds = [...sections].map(s => s.dataset.sectionId).join(',');
    const url = new URL(window.location.href);

    url.searchParams.set('sections', sectionIds);
    url.searchParams.set('lazyload', 'false');

    try {
      const res = await fetch(url.toString());
      const data = await res.json();
      sections.forEach(section => {
        const id = section.dataset.sectionId;
        const html = data[id];
        if (!html) return;

        const parsed = new DOMParser().parseFromString(html, 'text/html');

        const newSection = parsed.querySelector('[data-section-type="cart-template"]');
        if (newSection) {
          section.replaceWith(newSection);
          return;
        }

        const newContainer = parsed.querySelector('.js-cart-container');
        const container = section.querySelector('.js-cart-container');

        if (container && newContainer) {
          container.innerHTML = newContainer.innerHTML;
        }
      });

      const hasItems = document.querySelector('[data-cart-item]');
      document
        .querySelectorAll('[data-section-type="cart-template"]')
        .forEach(sec => sec.classList.toggle('is-empty', !hasItems));

      window.themeCore?.Cart?.init?.();

    } catch (err) {
      console.error('Cart refresh failed:', err);
    }
  }

  /* Remove Handler (Debounced + Clean) */
  function initCartRemovalFix() {
    let isProcessing = false;
    const cartContainer = document.querySelector('.template-cart');
    if (cartContainer) {
    cartContainer.addEventListener('click', async (e) => {
      const btn = e.target.closest('.js-cart-item-remove');
      const removeBtns = cartContainer.querySelectorAll('.js-cart-item-remove');

      if (!btn || isProcessing || removeBtns.length !== 2) return;

      isProcessing = true;

      try {
        // Wait for native cart update (Shopify AJAX)
        await new Promise(resolve => setTimeout(resolve, 600));
        await refreshCartSections();
        // Optional safety retry (only if still items mismatch)
        if (document.querySelector('[data-cart-item]')) {
          await new Promise(resolve => setTimeout(resolve, 300));
          await refreshCartSections();
        }

      } finally {
        isProcessing = false;
      }
    }, true);
  }
  }

  /* Init */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartRemovalFix);
  } else {
    initCartRemovalFix();
  }

  // Quantity input field validation
  const selectors = {
    productInventory: "[data-product-inventory]",
    container: "[data-js-product-container]",
  };
  function initProductQuantityValidation() {
    const container = document.querySelector(selectors.container);
    if (!container) return;

    const productInventoryInfo = container.querySelector(selectors.productInventory);
    if (!productInventoryInfo) return;
    let inventoryMap = {};

    try {
      const parsedInventory = JSON.parse(productInventoryInfo.innerText);

      inventoryMap = Object.fromEntries(
        parsedInventory
          .filter(v => v.inventory_management === "shopify")
          .map(v => [v.id, v.inventory_quantity])
      );

    } catch (e) {
      console.error("Invalid inventory JSON", e);
    }

    const quantityInput = container.querySelector('[data-quantity-input]');
    const increaseBtn = container.querySelector('[data-quantity-increase]');
    const variantSelector = container.querySelectorAll('input.radio-input');

    if (!quantityInput || !increaseBtn) return;

    let currentVariantId = null;

    // Get current variant
    function getCurrentVariantId() {
      if (currentVariantId) return currentVariantId;

      const variantInput = container.querySelector('form[action*="/cart/add"] [name="id"]');
      return variantInput ? Number(variantInput.value) : null;
    }

    // Quantity validation
    function quantityValidation() {
      const variantId = getCurrentVariantId();
      const inventory = inventoryMap[variantId];
      if (!variantId || inventory == null){
        increaseBtn.disabled = false;
        return;
      }
      let value = Number(quantityInput.value) || 1;
      value = Math.max(1, Math.min(value, inventory));
      quantityInput.value = value;
      increaseBtn.disabled = value >= inventory;
    }

    quantityInput.addEventListener('input', quantityValidation);
    quantityInput.addEventListener('change', quantityValidation);
    increaseBtn.addEventListener('click', quantityValidation);

    // Variant change (radio buttons)
    variantSelector.forEach(selector => {
      selector.addEventListener('change', () => {
        quantityInput.value = 1;
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        setTimeout(quantityValidation, 0);
      });
    });

    // Shopify variant change event
    document.addEventListener('product:variant:change', (event) => {
      currentVariantId = Number(event.detail);
      quantityValidation();
    });

    // Initial run
    quantityValidation();
  }
  try {
    initProductQuantityValidation();
  } catch (e) {
    console.error(e);
  }
})();